/** Scheduler page_configuration capability flags (Schedule Builder /scheduler). */

function isConfigFlagTrue(value) {
  return value === true;
}

/**
 * @param {object|null|undefined} configuration
 */
export function getSchedulerPageCapabilities(configuration) {
  const cfg = configuration && typeof configuration === 'object' ? configuration : {};
  return {
    createAllOrganizations: isConfigFlagTrue(cfg.can_create_periods_all_organizations),
    editAllOrganizations: isConfigFlagTrue(cfg.can_edit_periods_all_organizations),
    removeAllOrganizations: isConfigFlagTrue(cfg.can_remove_periods_all_organizations),
    createOwnOrganization: isConfigFlagTrue(cfg.can_create_periods_own_organization),
    editOwnOrganization: isConfigFlagTrue(cfg.can_edit_periods_own_organization),
    removeOwnOrganization: isConfigFlagTrue(cfg.can_remove_periods_own_organization)
  };
}

/**
 * Organization groups.id for the user's active membership (nav context).
 * @param {{ organization_group_id: string|number, name: string }[]} organizations
 * @param {{ parent_group_name?: string, group_name?: string, group_type?: string }|null} currentRole
 */
export function resolveCurrentOrganizationGroupId(organizations, currentRole) {
  if (!currentRole) return null;
  const byName = new Map(
    (organizations || []).map((o) => [
      String(o.name || '')
        .trim()
        .toLowerCase(),
      String(o.organization_group_id)
    ])
  );
  if (
    currentRole.group_type === 'organization' ||
    currentRole.group_type === 'system'
  ) {
    const id = byName.get(String(currentRole.group_name || '').trim().toLowerCase());
    if (id) return id;
  }
  const parentId = byName.get(String(currentRole.parent_group_name || '').trim().toLowerCase());
  return parentId || null;
}

function isOwnOrganization(targetOrgGroupId, currentOrgGroupId) {
  if (!targetOrgGroupId || !currentOrgGroupId) return false;
  return String(targetOrgGroupId) === String(currentOrgGroupId);
}

/**
 * @param {ReturnType<typeof getSchedulerPageCapabilities>} caps
 * @param {'create'|'edit'|'remove'} action
 * @param {string|number|null|undefined} targetOrgGroupId
 * @param {string|number|null|undefined} currentOrgGroupId — active membership org (groups.id)
 */
export function canSchedulerActOnOrganization(caps, action, targetOrgGroupId, currentOrgGroupId) {
  const own = isOwnOrganization(targetOrgGroupId, currentOrgGroupId);
  if (action === 'create') {
    return caps.createAllOrganizations || (caps.createOwnOrganization && own);
  }
  if (action === 'edit') {
    return caps.editAllOrganizations || (caps.editOwnOrganization && own);
  }
  if (action === 'remove') {
    return caps.removeAllOrganizations || (caps.removeOwnOrganization && own);
  }
  return false;
}

/**
 * @deprecated Use resolveCurrentOrganizationGroupId for permission checks.
 * Kept for org-picker defaults that consider all enrollments.
 */
export function resolveViewerOrganizationGroupIds(organizations, currentRole, availableUgp = []) {
  const byName = new Map(
    (organizations || []).map((o) => [
      String(o.name || '')
        .trim()
        .toLowerCase(),
      String(o.organization_group_id)
    ])
  );
  const ids = new Set();

  const addByName = (name) => {
    const id = byName.get(String(name || '').trim().toLowerCase());
    if (id) ids.add(id);
  };

  if (currentRole) {
    if (
      currentRole.group_type === 'organization' ||
      currentRole.group_type === 'system'
    ) {
      addByName(currentRole.group_name);
    }
    addByName(currentRole.parent_group_name);
  }

  (availableUgp || []).forEach((ugp) => {
    if (ugp.group_type === 'organization' || ugp.group_type === 'system') {
      addByName(ugp.group_name);
    }
    addByName(ugp.parent_group_name);
  });

  return [...ids];
}
